var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.67,
    height: 46.49,
    viewBox: "0 0 49.67 46.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 26.72 15.43 46.49 40.26 43.02 26.15 13.36 0 26.72",
    fill: "#99c1de"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.24 0 49.67 19.77 40.26 43.02 24.84 23.25 20.13 10.47 34.24 0",
    fill: "#b8d4e8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.84 23.25 34.24 0 9.41 3.48 0 26.72 24.84 23.25",
    fill: "#d6e6f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance4);
export default __webpack_public_path__ + "static/media/entrance_4.1acce2fab9ec7658cbf080433e9465a3.svg";
export { ForwardRef as ReactComponent };